import { Col, Container, Image, Row } from 'react-bootstrap';

const HeroSection = () => {
  return (
    <Container className='relative'>
      <Row className='items-center justify-between pt-0 llg:items-center sm:!pt-16 llg:h-[85vh] h-[calc(100vh-175px)] md:h-[calc(650px-80px)] sm:h-[calc(550px-80px)]'>
        <Col lg={6} md={6} sm={8}>
          <span className='text-xmd font-serif font-medium uppercase text-tprimary block mb-[35px] xs:mb-[15px]'>
            Seamless Tracking
          </span>
          <h4 className='font-roboto font-bold text-tprimary !text-3xl uppercase mb-[2.5rem] sm:mb-[20px] xs:mb-[15px]'>
            Track Your Shipment with Confidence.
          </h4>
          <p className='text-xmd text-ttertiary leading-[30px] w-[85%] mb-12 lg:w-[90%] md:w-full xs:mb-[30px]'>
            Experience hassle-free tracking for your shipments. Stay updated
            with information, ensuring reliable and efficient delivery every
            step of the way.
          </p>
        </Col>

        <Col lg={6} md={6} sm={4} className='flex justify-end'>
          <Image
            src='/assets/img/track-shipment/hero.jpg'
            alt='gold'
            className='object-cover h-full sm:hidden flex'
            width='570px'
          />
        </Col>
      </Row>
    </Container>
  );
};

export default HeroSection;
